import * as constants from '@/core/constants'

export default {
    data() {
        return {
            ...constants
        }
    }
}
